import { useDispatch, useSelector } from "react-redux";
import { MandatoryStar, getSnackbarSuccess } from "../../../Utils/helper";
import { getNetworkMenuId } from "../../../Utils/types";
import Select from "react-select";
import { useState } from "react";
import {
  approveRejectTestDetailsAction,
  getPackageDetailNewPopupAction,
  getPackageDetailUpdatePopupAction,
  getPackageWiseClientsDetailsNetworkAction,
} from "../../../redux/actions/ProviderProfileDetailAction";
import { useEffect } from "react";

export const ConfirmationPackagePopup = ({
  isApproveReject,
  setIsApproveReject,
  rowData,
  handleClose,
  newSearchFilterPackage,
  updateSearchFilterPackage,
}) => {
  const dispatch = useDispatch();
  const [remark, setRemark] = useState("");
  const [clientDetails, setClientDetails] = useState(null);

  const providerPortalDetailReducer = useSelector(
    (state) => state?.providerPortalDetailReducer
  );

  useEffect(() => {
    if (isApproveReject?.packageId) {
      const resp = dispatch(
        getPackageWiseClientsDetailsNetworkAction(isApproveReject?.packageId)
      );
      resp.then((res) => {
        setClientDetails(res?.data?.results);
      });
    }
  }, [isApproveReject?.packageId]);

  const ApproveRejectHandler = async (type) => {
    const temp = {
      requestID: rowData?.requestID,
      requestStatus: rowData?.requestStatus === "PendingAppPrice" ? "AppPriceDetail" : type,
      sessionID: rowData?.sessionID,
      providerFacilityStgId: isApproveReject?.providerPackageStgId,
      facilityId: isApproveReject?.packageId,
      agreedRate:
        isApproveReject?.agreedRate === "" ? 0 : isApproveReject?.agreedRate,
      remarks: remark,
      providerId:rowData?.providerID,
      appPrice1Graded:+isApproveReject?.appPrice1Graded
    };
    if(rowData?.requestStatus === "PendingAppPrice" && temp?.appPrice1Graded === 0){
      getSnackbarSuccess(
        "info",
        "App Price is required",
        dispatch
      );
    }else if (isApproveReject?.agreedRate == 0 && type === "APPROVED") {
      getSnackbarSuccess(
        "info",
        "agreed rate should be greater than 0",
        dispatch
      );
    } else if (
      isApproveReject?.packageId === undefined ||
      isApproveReject?.packageId === null ||
      (isApproveReject?.agreedRate === "" && type === "APPROVED")
    ) {
      getSnackbarSuccess(
        "info",
        "Please fill all the required fields",
        dispatch
      );
    } else if (type === "REJECTED" && /^\s*$/.test(remark)) {
      getSnackbarSuccess(
        "info",
        "Please specify the reason for rejecting this request ?",
        dispatch
      );
    } else {
      await dispatch(approveRejectTestDetailsAction(temp, handleClose));
      await dispatch(getPackageDetailNewPopupAction(newSearchFilterPackage));
      await dispatch(
        getPackageDetailUpdatePopupAction(updateSearchFilterPackage)
      );
      await setIsApproveReject(null);
      await setRemark("");
    }
  };

  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black">
          Approval Card&nbsp;
          {clientDetails?.[0]?.packageType === "Client Specific"
            ? `(${clientDetails?.[0]?.packageType})`
            : null}
        </h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={() => setIsApproveReject(null)}
        ></button>
      </div>
      <form className="form-admin test-confirmationpopup">
        <div className="modal-body addusermodalbox">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <label htmlFor=" Role" className="col-form-label">
                Agreed Rate
                <MandatoryStar />
              </label>
              <input
                type="text"
                placeholder="Agreed Rate"
                className="form-control form-select-admin inputbgavanish"
                value={isApproveReject?.agreedRate}
                onChange={(e) =>
                  setIsApproveReject({
                    ...isApproveReject,
                    agreedRate: e.target.value,
                  })
                }
                onKeyPress={(event) => {
                  const regex = /^[0-9]*(\.[0-9]{0,2})?$/;
                  if (!regex.test(isApproveReject?.agreedRate + event.key)) {
                    event.preventDefault();
                  }
                }}
                disabled={isApproveReject?.requestStatus !== "InReview"}
              />
            </div>
            {rowData?.detailType === "AppPriceDetail" && <div className="col-lg-6 col-md-6">
              <label htmlFor=" Role" className="col-form-label">
                App Price
                <MandatoryStar />
              </label>
              <input
                type="text"
                placeholder="App Price"
                className="form-control form-select-admin inputbgavanish"
                value={isApproveReject?.appPrice1Graded}
                onChange={(e) =>
                  setIsApproveReject({
                    ...isApproveReject,
                    appPrice1Graded: e.target.value,
                  })
                }
                onKeyPress={(event) => {
                  const regex = /^\d*\.?\d*$/;
                  if (!regex.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                disabled={isApproveReject?.requestStatus !== "PendingAppPrice"}
              />
            </div>}
            <div className="col-lg-6 col-md-6">
              <label htmlFor=" Role" className="col-form-label">
                HA SKU Code
                <MandatoryStar />
              </label>
              <Select
                className="basic-multi-select select_provider_test"
                classNamePrefix="select"
                name="colors"
                placeholder="HA SKU Code"
                isClearable={true}
                options={providerPortalDetailReducer?.getFacilityReason?.map(
                  (ele) => {
                    return {
                      value: ele?.facilityId,
                      label: ele?.facilityName,
                    };
                  }
                )}
                onChange={(e) => {
                  setIsApproveReject({
                    ...isApproveReject,
                    packageId: e?.value,
                    haPackageName: e?.label,
                  });
                }}
                value={{
                  value: isApproveReject?.packageId,
                  label: isApproveReject?.haPackageName,
                }}
                isDisabled={isApproveReject?.requestStatus !== "InReview"}
              />
            </div>
          </div>
          {clientDetails?.[0]?.packageType === "Standard (Applicable on All CBU Client)" && (
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <label htmlFor=" Role" className="col-form-label">
                  Package Type
                </label>
                <input
                  type="text"
                  placeholder="Package Type"
                  className="form-control form-select-admin inputbgavanish"
                  value={clientDetails?.[0]?.packageType}
                  disabled={true}
                  readOnly={true}
                />
              </div>
              <div className="col-lg-6 col-md-6">
                <label htmlFor=" Role" className="col-form-label">
                  App Customer Rate
                </label>
                <input
                  type="text"
                  placeholder="App Customer Rate"
                  className="form-control form-select-admin inputbgavanish"
                  value={clientDetails?.[0]?.appCustomerRate}
                  disabled={true}
                  readOnly={true}
                />
              </div>
            </div>
          )}
          {clientDetails?.[0]?.packageType === "Client Specific" && (
            <div className="remarks mt-3">
              <h5 className="font-bold text-black bottom-spacing-20 mb-3">
                Client Lists
              </h5>
              <div
                className="table-responsive __custom__properties"
                style={{ overflowY: "scroll", height: "155px" }}
              >
                <table className="table" style={{ overflow: "hidden" }}>
                  <thead>
                    <tr>
                      <th scope="col">Client Name</th>
                      <th scope="col">App Customer Rate</th>
                    </tr>
                  </thead>
                  <tbody>
                    {clientDetails?.map((ele, index) => {
                      return (
                        <tr key={index}>
                          <td>{ele?.clientName}</td>
                          <td className="width-80">{ele?.appCustomerRate}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {rowData?.detailType !== "AppPriceDetail" &&  <div className="remarks mt-2 mb-3">
            <h5 className="font-bold text-black bottom-spacing-20 mb-3">
              Remarks
            </h5>
            <textarea
              className="textareaConfirmation font-medium"
              style={{ height: "100px" }}
              placeholder="Type Something Here..."
              onChange={(e) => setRemark(e.target.value)}
              value={
                isApproveReject?.requestStatus !== "InReview"
                  ? isApproveReject?.remarks
                  : remark
              }
              disabled={
                isApproveReject?.requestStatus !== "InReview" ||
                !getNetworkMenuId()?.canEdit
              }
            ></textarea>
          </div>}
        </div>
        <div className="modal-footer modal-footer-admin accept-reject-btns bottom-0  mt-4">
          {(isApproveReject?.requestStatus === "InReview" || isApproveReject?.requestStatus === "PendingAppPrice" )&&
            getNetworkMenuId()?.canEdit && (
              <div className="d-flex justify-content-end flex-wrap gap-10">
                <button
                  type="button"
                  onClick={async () => {
                    await ApproveRejectHandler("APPROVED");
                  }}
                  className="approve-btn"
                >
                  Approve
                </button>
                {rowData?.detailType !== "AppPriceDetail" && <button
                  type="button"
                  onClick={async () => {
                    await ApproveRejectHandler("REJECTED");
                  }}
                  className="reject-btn"
                >
                  Reject
                </button>}
              </div>
            )}
        </div>
      </form>
    </>
  );
};
